export const supportedLangCodes = ['en', 'ko', 'zh', 'ja', 'vi', 'es', 'ar', 'de', 'fr', 'it', 'pt', 'ru'] as const

type SupportedLangCodes = typeof supportedLangCodes[number]
export const supportLanguageList: SupportedLanguage[] = [
  { name: 'English', code: 'en', emoji: '🇺🇸' },
  { name: 'Korean', code: 'ko', emoji: '🇰🇷' },
  { name: 'Chinese', code: 'zh', emoji: '🇨🇳' },
  { name: 'Japanese', code: 'ja', emoji: '🇯🇵' },
  { name: 'Vietnamese', code: 'vi', emoji: '🇻🇳' },
  { name: 'Spanish', code: 'es', emoji: '🇪🇸' },
  { name: 'Arabic', code: 'ar', emoji: '🇦🇪' },
  { name: 'German', code: 'de', emoji: '🇩🇪' },
  { name: 'French', code: 'fr', emoji: '🇫🇷' },
  { name: 'Italian', code: 'it', emoji: '🇮🇹' },
  { name: 'Portuguese', code: 'pt', emoji: '🇵🇹' },
  { name: 'Russian', code: 'ru', emoji: '🇷🇺' },
  { name: 'Others', code: 'Others', emoji: '🌏' },
]

export const findCodeAndEmoji = (code: string) => {
  const res = supportLanguageList.find((d) => {
    if (d.code === code) {
      return true
    } else if (d.code === 'Others') {
      return true
    }
  })
  return res
}

type SupportedLanguage = {
  name: string
  code: SupportedLangCodes | 'Others'
  emoji: string
}
